import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const links = [
  { label: "Categorias", href: "#categorias" },
  { label: "Recursos", href: "#recursos" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Lojistas", href: "#lojistas" },
  { label: "Planos", href: "/planos" },
  { label: "Contato", href: "#contato" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-black/5 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-8xl items-center justify-between px-5 md:px-10">
        <a href="#topo" data-testid="brand-logo" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-maraca-navy font-display text-lg font-extrabold text-white">M</span>
          <span className="font-display text-xl font-extrabold tracking-tight text-maraca-navy">
            Delivery <span className="text-maraca-teal">Maracás</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-semibold text-maraca-navy/80 transition-colors hover:text-maraca-teal"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/cadastro"
            data-testid="header-store-cta"
            className="rounded-full bg-maraca-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-300 hover:-translate-y-0.5 hover:bg-[#0a3179]"
          >
            Cadastre sua loja
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-black/10 text-maraca-navy md:hidden"
          aria-label="Abrir menu"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-black/5 bg-white md:hidden"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-3 py-3 text-base font-semibold text-maraca-navy hover:bg-maraca-teal/10"
                >
                  {l.label}
                </a>
              ))}
              <Link
                to="/cadastro"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-full bg-maraca-navy px-5 py-3 text-center font-bold text-white"
              >
                Cadastre sua loja
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
